<template>
  <span class="inline-flex whitespace-nowrap rounded shadow-sm">
    <button
      type="button"
      class="inline-flex items-center py-2 px-3 w-full text-sm font-medium tracking-wider leading-4 uppercase rounded border transition duration-150 ease-in-out focus:outline-none"
      :class="typeClass"
      :disabled="disabled"
      @click.stop="$emit('click')"
    >
      <i v-if="icon" class="far fa-fw" :class="[icon, text && 'mr-2 -ml-0.5']" />
      <span v-text="text" />
    </button>
  </span>
</template>

<script>
  export default {
    name: 'VButton',
    props: {
      text: { type: String, required: false },
      icon: { type: String, required: false },
      primary: { type: Boolean, required: false, default: false },
      secondary: { type: Boolean, required: false, default: false },
      danger: { type: Boolean, required: false, default: false },
      disabled: { type: Boolean, required: false, default: false },
      center: { type: Boolean, required: false, default: false }
    },
    emits: ['click'],
    computed: {
      typeClass () {
        let output = ''
        if (this.center) output = 'justify-center '
        if (this.disabled) return output + 'text-gray-400 border-gray-400'
        if (this.primary) return output + 'text-primary-50 bg-primary-700 border-transparent hover:bg-primary-800 focus:outline-none focus:border-primary-900 active:bg-primary-900'
        if (this.secondary) return output + 'text-primary-700 border-primary-700 hover:text-primary-600 focus:outline-none focus:border-primary-800 active:text-primary-800 active:bg-gray-50'
        if (this.danger) return output + 'text-red-700 border-red-500 hover:text-red-600 focus:outline-none focus:border-red-800 active:text-red-800 active:bg-red-50'

        return output + 'text-gray-700 border-gray-500 hover:text-gray-600 focus:outline-none focus:border-gray-800 active:text-gray-800 active:bg-gray-50'
      }
    }
  }
</script>
